import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { Starfield } from "@/components/site/Starfield";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

let lenis;

const SmoothScroll = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    lenis = new Lenis({ duration: 1.2, autoRaf: true });
    return () => { lenis.destroy(); };
  }, []);
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="grain min-h-screen relative">
      <BrowserRouter>
        <SmoothScroll />
        <Starfield />
        <Navbar />
        <main className="relative z-10">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
